export default function getScreenOrientation() {
  // checks for matchMedia support
  if (window.matchMedia) return window.matchMedia('(orientation: landscape)').matches ? 'landscape' : 'portrait';
  // fallbacks to the viewport size
  return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
}
